/**
 * Logic Necessary for the CPE Detail
 * List View
 * Author: Imarc 2019
 */

// Dependencies
import stickybits from 'stickybits';
import classToggle from '@inkwell/scripts/modules/classtoggle';
import '../modules/couponadd';

// Executions
classToggle({});
const checkoutStickyInstance = stickybits('.js-checkout', {
    useFixed: true,
    stickyBitStickyOffset: 32,
    useGetBoundingClientRect: true,
});

window.addEventListener('scroll', () => {
    let ticking = false;

    if (!ticking) {
        window.requestAnimationFrame(() => {
            checkoutStickyInstance.update();
        });

        ticking = true;
    }
});

// Turn off sticky instance when window width is less than 550px
if (window.innerWidth <= '550') {
    checkoutStickyInstance.update({useFixed: false})
}